import React from "react";

function Interested() {
  return (
    <>
      <div className="container mt-50 mb-50 ">
        <div
          className="testimonial-style-three-items bg-gray blurry-shape-right-bottom"
          // style={{ backgroundImage: "url(assets/img/shape/3.html)" }}
        >
          <div className="testimonial-style-three-carousel swiper">
            <div className="swiper-wrapper">
              <div className="testimonial-style-three">
                <div className="left">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/shape/12.png"
                    alt="Image Not Found"
                  />
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/icon/quote-two.png"
                    alt="Image Not Found"
                  />
                </div>
                <div className="right">
                  <p>
                    Interested? Experience our white label crypto exchange
                    platform firsthand. Schedule a personalized demo to explore
                    its features & see how it fulfills your needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Interested;
